import VERTEX_SHADER from "../shaders/base-overlay.vs";
import FRAGMENT_SHADER from "../shaders/ground/ground-mix.fs";

class MaterialGroundMix extends THREE.ShaderMaterial {
    constructor(shadowMap) {
        const defines = {
            USE_MAP: "",
            USE_PERSPECTIVE_CAMERA: ""
        };
        const uniforms = {
            map: new THREE.Uniform(shadowMap),
            uvTransform: new THREE.Uniform(new THREE.Matrix3()),
            cameraNear: new THREE.Uniform(0),
            cameraFar: new THREE.Uniform(0),
            cameraCutoff: new THREE.Uniform(50)
        };

        super({
            defines,
            uniforms,
            vertexShader: VERTEX_SHADER,
            fragmentShader: FRAGMENT_SHADER
        });
    }

    /**
     * 
     * @param {THREE.Camera} camera 
     */
    updateCamera(shadowCamera) {
        this.uniforms.cameraNear.value = shadowCamera.near;
        this.uniforms.cameraFar.value = shadowCamera.far;
    }
}

export default MaterialGroundMix;
export { MaterialGroundMix };